/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Sync_Title4Inputs */

const en_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cross-tool workflows`)
};

const ar_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سير عمل عبر الأدوات`)
};

const bn_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্রস-টুল ওয়ার্কফ্লো`)
};

const de_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolübergreifende Arbeitsabläufe`)
};

const es_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujos de trabajo entre herramientas`)
};

const fr_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux de travail multi-outils`)
};

const pt_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxos de trabalho entre ferramentas`)
};

const zh_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跨工具工作流程`)
};

const tr_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Araçlar arası iş akışları`)
};

const ru_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочие процессы с использованием различных инструментов`)
};

const pl_svc_automation_sync_title4 = /** @type {(inputs: Svc_Automation_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przepływy pracy między narzędziami`)
};

/**
* | output |
* | --- |
* | "Cross-tool workflows" |
*
* @param {Svc_Automation_Sync_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_sync_title4 = /** @type {((inputs?: Svc_Automation_Sync_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Sync_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_sync_title4(inputs)
	if (locale === "bn") return bn_svc_automation_sync_title4(inputs)
	if (locale === "de") return de_svc_automation_sync_title4(inputs)
	if (locale === "es") return es_svc_automation_sync_title4(inputs)
	if (locale === "fr") return fr_svc_automation_sync_title4(inputs)
	if (locale === "pt") return pt_svc_automation_sync_title4(inputs)
	if (locale === "zh") return zh_svc_automation_sync_title4(inputs)
	if (locale === "tr") return tr_svc_automation_sync_title4(inputs)
	if (locale === "ru") return ru_svc_automation_sync_title4(inputs)
	if (locale === "pl") return pl_svc_automation_sync_title4(inputs)
	return en_svc_automation_sync_title4(inputs)
});
export { svc_automation_sync_title4 as "svc_automation_SYNC_title" }